export default "__VITE_ASSET__CY_yTm0W__"